import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, flex, mb, ml, mr, p} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {investmentOffer, pluralize} from "@pg-mono/string-utils";

import {InlineButton} from "../../atoms/InlineButton";
import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IProps {
    vendor: {
        awards_count: number;
        name: string;
        logo_url: string | null;
        stats: {
            properties_count_for_sale: number;
            offers_count_for_sale: number;
            offers_count_sold: number;
        };
        slug: string;
        id: number;
    };
}

const awardsQuantityPlural = pluralize(["nagroda i wyróżnienie", "nagrody i wyróżnienia", "nagród i wyróżnień"]);

export const VendorTrustCertificate = (props: IProps) => {
    const theme = useTheme();

    const {vendor} = props;
    const awards = vendor.awards_count;
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id});
    const target = useResponsiveLinkTarget();

    const onShowVendorAwards = () => {
        window.open(vendorLink, target);
    };

    return (
        <div css={vendorTrustCertificate}>
            <div css={vendorTrustInfoSection}>
                <div>
                    <img width={149} height={110} alt={`${props.vendor.name} logo`} src={getThumbnailLink(props.vendor.logo_url, 160, 120)} css={vendorLogo} />
                </div>

                <div css={awardsWrapper}>
                    <div css={[flex("center")]}>
                        <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />
                        <Text as="p" variant="info_txt_1">
                            W sprzedaży {vendor.stats.properties_count_for_sale} nieruchomości w {vendor.stats.offers_count_for_sale} inwestycjach
                        </Text>
                    </div>

                    {awards && (
                        <div css={[flex("center")]}>
                            <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />

                            <Text as="p" variant="info_txt_1">
                                {awards} {awardsQuantityPlural(awards)}
                            </Text>

                            <InlineButton css={ml(2)} onClick={onShowVendorAwards}>
                                <Text variant="button_micro">ZOBACZ</Text>
                            </InlineButton>
                        </div>
                    )}

                    {vendor.stats.offers_count_sold > 0 && (
                        <div css={[flex("center")]}>
                            <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />

                            <Text as="p" variant="info_txt_1">
                                Zrealizował i zakończył sprzedaż w {vendor.stats.offers_count_sold} {investmentOffer.locative(vendor.stats.offers_count_sold)}
                            </Text>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const vendorTrustCertificate = (theme: Theme) => css`
    ${p(3)};
    ${flex()};
    ${borderRadius(2)};
    background-color: #fff;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;

const vendorTrustInfoSection = (theme: Theme) => css`
    ${flex("center")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;

const vendorLogo = (theme: Theme) => css`
    ${mb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mr(5)};
        ${mb(0)};
    }
`;

const awardsWrapper = css`
    & > div {
        ${flex("center")}

        &:not(:last-of-type) {
            ${mb(2)};
        }
    }
`;
import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, flex, mb, ml, mr, p} from "@pg-design/helpers-css";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {investmentOffer, pluralize} from "@pg-mono/string-utils";

import {InlineButton} from "../../atoms/InlineButton";
import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IProps {
    vendor: {
        awards_count: number;
        name: string;
        logo_url: string | null;
        stats: {
            properties_count_for_sale: number;
            offers_count_for_sale: number;
            offers_count_sold: number;
        };
        slug: string;
        id: number;
    };
}

const awardsQuantityPlural = pluralize(["nagroda i wyróżnienie", "nagrody i wyróżnienia", "nagród i wyróżnień"]);

export const VendorTrustCertificate = (props: IProps) => {
    const theme = useTheme();

    const {vendor} = props;
    const awards = vendor.awards_count;
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id});
    const target = useResponsiveLinkTarget();

    const onShowVendorAwards = () => {
        window.open(vendorLink, target);
    };

    return (
        <div css={vendorTrustCertificate}>
            <div css={vendorTrustInfoSection}>
                <div>
                    <img width={149} height={110} alt={`${props.vendor.name} logo`} src={getThumbnailLink(props.vendor.logo_url, 160, 120)} css={vendorLogo} />
                </div>

                <div css={awardsWrapper}>
                    <div css={[flex("center")]}>
                        <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />
                        <Text as="p" variant="info_txt_1">
                            W sprzedaży {vendor.stats.properties_count_for_sale} nieruchomości w {vendor.stats.offers_count_for_sale} inwestycjach
                        </Text>
                    </div>

                    {awards && (
                        <div css={[flex("center")]}>
                            <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />

                            <Text as="p" variant="info_txt_1">
                                {awards} {awardsQuantityPlural(awards)}
                            </Text>

                            <InlineButton css={ml(2)} onClick={onShowVendorAwards}>
                                <Text variant="button_micro">ZOBACZ</Text>
                            </InlineButton>
                        </div>
                    )}

                    {vendor.stats.offers_count_sold > 0 && (
                        <div css={[flex("center")]}>
                            <BrandCheckboxCheckedIcon css={mr(2)} size="2.4" wrapperColor={theme.colors.primary} wrapperSize="2.4" />

                            <Text as="p" variant="info_txt_1">
                                Zrealizował i zakończył sprzedaż w {vendor.stats.offers_count_sold} {investmentOffer.locative(vendor.stats.offers_count_sold)}
                            </Text>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const vendorTrustCertificate = (theme: Theme) => css`
    ${p(3)};
    ${flex()};
    ${borderRadius(2)};
    background-color: #fff;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;

const vendorTrustInfoSection = (theme: Theme) => css`
    ${flex("center")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;

const vendorLogo = (theme: Theme) => css`
    ${mb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mr(5)};
        ${mb(0)};
    }
`;

const awardsWrapper = css`
    & > div {
        ${flex("center")}

        &:not(:last-of-type) {
            ${mb(2)};
        }
    }
`;
